import getUrlParameters from './getUrlParameters';


export default function getClientId(showMaxAccountSettingsPage: boolean) {
    const id = showMaxAccountSettingsPage ? process.env.REACT_APP_MAX_SSO_CLIENT_ID : process.env.REACT_APP_DEFAULT_SSO_CLIENT_ID;
    const defaultClientId =  id || 'bad-client-id';
    const urlParameters = getUrlParameters();
    return urlParameters.get('client_id') || defaultClientId;
}
